<template>
  <div>
    <!-- <img class="backimg" src="../assets/c_bei.png" alt=""> -->
    <div class="aboutus_container" v-if="flaghome">
      <div class="aboutus_wrapper">
        <div class="aboutus_menu">
          <div class="menu_title">
            <p class="title">关于</p>
            <p class="border"></p>
            <p class="name">About us</p>
          </div>
          <ul class="menu_list">
            <li v-for="(item, index) in tabList" :key="index" @click="handleToggleTab(index)">
              <div class="menu_item_title">
                <div v-if="activeTab == item.id" class="menu_bg">
                  <img src="../assets/tabBg.svg" alt="">
                  <div class="menu_bg_info">{{ item.title }} <i v-if="item.list" class="el-icon-arrow-up"></i></div>
                </div>
                <div v-else>
                  {{ item.title }} <i v-if="item.list" class="el-icon-arrow-down"></i>
                </div>

              </div>

              <ul v-if="activeTab == item.id" class="menu_drow">
                <li style="width: 138px" v-for="(curr, currIndex) in item.list"
                  :class="childActive == curr.id ? 'active' : ''" :key="currIndex"
                  @click.stop="handleToggleChildTab(index, currIndex)">{{ curr.title }}</li>
              </ul>
            </li>

          </ul>
        </div>
        <div class="aboutus_info" v-if="activeTab == 3">
          <div style="margin-left: 50px; margin-top: 10px;">

            <h2>新闻公告</h2>
            <ul style="margin-top: 20px;" element-loading-text="数据加载中" v-loading="loading">

              <li v-for="(item, index) in datalist" :key="index" @click="handleClick(item)"
                style="height: 100px; border-bottom:1px solid #ccc;line-height: 30px;display: flex;cursor: pointer;">
                <div
                  style="width: 59px; height: 63px;border-radius: 5px;background: linear-gradient(119deg, #EEC484 0%, #C49958 100%);margin-top: 20px;color: white;">
                  <p style="margin-left: 11px !important;">{{ item.createTimes }}月</p>

                  <p style="font-size: 19px;font-weight: 600;margin-top: -13px;text-align: center;">{{ item.datetimer }}
                  </p>

                </div>
                <b
                  style="display: block;color:#2c3e50; line-height: 100px;margin-left: 20px;font-family: Source Han Sans;">{{
                    item.noticeTitle }}</b>
              </li>

            </ul>
            <div class="block" style="margin-top: 100px;position: fixed;top: 83%;left: 48%;">
              <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage4" :page-sizes="[10, 20, 30, 40]" :page-size="pagesize"
                layout="total, prev, pager, next, jumper" :total="total">
              </el-pagination>
            </div>
          </div>

        </div>
        <div class="aboutus_info" v-else-if="activeTab == 1 && childActive == '1-1'">
          <div style="margin-left: 20px; margin-top: 10px;">
            <h2>平台简介</h2>
            <img src="../assets/容器 65.png" style="margin-top: 20px;" alt="">
            <p style="margin-top: 30px;">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;中国长城互联网(以下简称长城网)，是经国务院、中央军委正式批准，由国家统一组织建设的军民共建共用、安全保密互联网络，是国家授权的全国八大基础互联单位之一，是军方相关单位联接互联网的唯一合规通道，也是中央融办唯一指定的信息服务网络平台。中国长城互联网信息中心是长城网的军方专职管理机构。
            </p>
            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;中国长城产融服务平台，是在基于长城网信息安全底座基础上，由中国长城互联网信息中心联合中国航天科技集团供应链协同服务中心，北京北信源软件股份有限公司、国科智造（北京）有限公司等单位共同打造的国防工业数字化产融信息服务平台。平台重点面向各军队单位和航天科技等各大军工集团所属单位及其供应链配套企业，提供股权投资、债权融资、票据贴现等各类供应链金融信息服务及产融数字化领域的相关技术服务，有效解决军队和军工市场供应链金融业务长期面临的信息不对称、融资成本高、额度不够用、响应速度慢等问题，为军队和军工供应链企业，特别是工业基础领域科技创新型企业提供资金支持，以金融科技力量推动国防军工制造业高质量高效益可持续发展，确保国防工业供应链产业链战略安全。
            </p>

          </div>
        </div>
        <div class="aboutus_info" v-else-if="activeTab == 1 && childActive == '1-2'">
          <div style="margin-left: 20px; margin-top: 10px;">
            <h2>公司简介</h2>
            <img src="../assets/容器 65 (1).png" style="margin-top: 20px;" alt="">
            <p style="margin-top: 30px;">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;国科智造（北京）科技有限公司，是国防工业关键技术观察站的实体运营单位，是中国长城互联网信息中心与中国国防工业企业协会、北京北信源软件股份有限公司等单位，联合打造的国防工业智能制造和供应链服务实体机构。
            </p>
            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              公司现已构建了一支覆盖军用基础领域和应用领域的军事观察员队伍，面向全国范围开展国防工业自主可控关键技术产品的需求发布、信息采集、研用对接、认证评估、技术指导和产业规划等工作，目标是成为推动国防军工产业自主可控高质量发展的重要支撑力量。
              服务用户：国防军工管理机构、军工企事业单位、广大民参军企业、各领域专家工程师设计师、推动科技成果转化的技术经理人团队、以及提供指导与服务的应用验证与认证评估机构、行业协会联盟、产业园区、投融资机构和供应链金融机构等。
            </p>

          </div>
        </div>
        <div class="aboutus_info2" v-else-if="activeTab == 2">
          <div style="margin-left: 40px; margin-top: 0px;">

            <ul class="info2_ul">
              <li class="info2_li">
                <h2 style="margin-left: -190px;margin-top: -6px;">平台使命</h2>
                <div style="position: relative;left: 57px;top: 25px;">
                  <img style="display: block; position: relative; width: 717px;left: 160px;top: -7px;" src="../assets/ggg(1).png"
                    alt="">
                  <h2 style="position: absolute;top: 30px;left: 260px;color: #c49958;font-size: 28px;">核心使命</h2>
              <li style="width: 200px; position: absolute;top:215px;left: 20px;">
                <p
                  style="width: 270px; text-align: center;font-weight: 600;color:#c49958;font-size: 22px;margin-left: -20px;">
                  产业与金融融合</p>
                <span
                  style="width: 260px; display: block; margin-top: 25px;margin-left: -25px; font-size: 18px;text-align: left;">促进国防军工产业与金融深度融合，实现协同发展，推动国防军工产业升级。</span>
              </li>
              <li style="width: 200px; position: absolute;top:65px;left: 800px;">
                <p style="width: 270px; text-align: left; font-weight: 600;color:#c49958;font-size: 22px;">行业影响力提升</p>
                <span
                  style="width: 270px; display: block; margin-top: 15px;font-size: 18px;text-align: left;">打造国防工业领域产融品牌，提升平台知名度。</span>
              </li>
              <li style="width: 200px; position: absolute;top:200px;left: 870px;">
                <p
                  style="text-align: center;margin-left: -55px; font-weight: 600;margin-top: 15px; color:#c49958;font-size: 22px;">
                  国家安全保障</p>
                <span
                  style="text-align: left; width: 320px; display: block; margin-top: 30px;margin-left: -40px; font-size: 18px;">支持军工核心能力建设，确保国防建设资金稳定，保障国防装备自主可控。</span>
              </li>
          </div>


          <!-- <div class="box" style="position: relative;">
                  <img style="position: relative; width: 400px;height: 400px;left: 400px;top: -7px;"
                    src="../assets/image (7).svg" alt=""></img>
                  <div style="position: absolute;top:0px;left: 510px;">
                    <img src="../assets/image.svg" style="width: 26px;height: 32px; margin-top: 0px;" alt="">
                    <h2 style="margin-top: -3px;">核心使命</h2>
                  </div>
                  <li style="width: 200px; position: absolute;top:130px;left: 150px;">
                    <p style="width: 270px; text-align: center;font-weight: 600;color:#c49958;font-size: 22px;">产业与金融融合</p>
                    <span style="width: 260px; display: block; margin-top: 5px;font-size: 18px;">促进国防军工产业与金融深度融合，实现协同发展，推动国防军工产业升级。</span>
                  </li>
                  <li style="width: 200px; position: absolute;top:330px;left: 500px;">
                    <p style="text-align: center;margin-left: -5px; font-weight: 600;margin-top: 15px; color:#c49958;font-size: 22px;">国家安全保障</p>
                    <span style="width: 320px; display: block; margin-top: 5px;margin-left: -53px; font-size: 18px;">支持军工核心能力建设，确保国防建设资金稳定，保障国防装备自主可控。</span>
                  </li>
                  <li style="width: 200px; position: absolute;top:130px;left: 800px;">
                    <p style="width: 270px; text-align: center; font-weight: 600;color:#c49958;font-size: 22px;">行业影响力提升</p>
                    <span style="width: 270px; display: block; margin-top: 5px;font-size: 18px;">打造国防工业领域产融品牌，提升平台知名度。</span>
                  </li>
                </div> -->



          <!-- <ul>
                  <li>
                    <p>产业与金融融合</p>
                    <span>促进国防军工产业与金融深度融合，实现协同发展，推动国防军工产业升级。</span>
                  </li>
                  <li>
                    <p>国家安全保障</p>
                    <span>支持军工核心能力建设，确保国防建设资金稳定，保障国防装备自主可控。</span>
                  </li>
                  <li>
                    <p>行业影响力提升</p>
                    <span>打造国防工业领域产融品牌，提升平台知名度。</span>
                  </li>
                  <li>
                    <img src="../assets/image (1).svg" alt="">
                  </li>
                </ul> -->
          </li>
          <li class="info2_li1">
            <div
              style="width: 83%;height: 50px;background-color: rgb(234, 218, 193);color: black;line-height: 50px;border-radius: 8px;opacity: 0.8;">
              <!-- <img src="../assets/image.svg" alt=""> -->
              <h2>推动产业发展</h2>
            </div>
            <ul>
              <li style="position: relative;">
                <img src="../assets/aa.svg" alt="">
                <p
                  style="position: absolute;width: 200px;color:black; top: 63px;left: 105px;font-size: 22px;font-weight: 600;">
                  提供多元化金融服务</p>
                <p
                  style="text-align: left; width: 320px; position: absolute;color:#2c3e50; top: 113px;left: 45px;font-size: 17px;">
                  提供订单融资贷款、绿色金融贷款、科技创新贷款等，支持推动民参军企业高质量发展，为企业提供创新资金支持。</p>
              </li>
              <li>
                <img style="width: 70px;height: 70px;margin-left: 110px;margin-top: 70px;" src="../assets/image (4).svg"
                  alt="">
              </li>
              <li style="margin-left: 0px !important;position: relative;">
                <img src="../assets/aa (1).svg" alt="">
                <p
                  style="position: absolute;width: 200px;color:black; top: 63px;left: 93px;font-size: 22px;font-weight: 600;">
                  助力产业转型
                </p>
                <p
                  style="position: absolute;width: 323px;color:#2c3e50; top: 113px;left: 45px;font-size: 17px;text-align: left;">
                  引导资金流向薄弱领域，强化产业链韧性，推动上下游企业合作，提升产业链效率。</p>
              </li>
            </ul>
          </li>
          <li class="info2_li2">
            <div
              style="width: 83%;height: 50px;background-color: rgb(234, 218, 193);color: black;line-height: 50px;border-radius: 8px;opacity: 0.8;">
              <h2>服务国家安全</h2>
            </div>
            <ul>
              <li>
                <p style="color:#c49958; font-size: 22px;font-weight: 600;">保障资金需求</p>
                <img src="../assets/bb1.svg" alt="">
                <p style="color:#2c3e50;font-size: 17px;">确保军工企业有稳定的资金来源，以满足企业科研生产方面的资金需求。
                </p>
              </li>
              <li>
                <p style="color:#c49958; font-size: 22px;font-weight: 600;">支持核心能力建设
                </p>
                <img src="../assets/bb1.svg" alt="">
                <p style="color:#2c3e50;font-size: 17px;">鼓励企业研发投入，突破核心技术瓶颈，确保核心关键零部件自主可控。
                </p>
              </li>
            </ul>
          </li>
          <li class="info2_li3">
            <div
              style="width: 83%;height: 50px;background-color: rgb(234, 218, 193);color: black;line-height: 50px;border-radius: 8px;opacity: 0.8;">
              <h2>促进产融结合</h2>
            </div>
            <ul>
              <li style="position: relative;">
                <img src="../assets/image (8).svg" alt="">
                <p style="position: absolute;top: 80px;left: 70px; color:black; font-size: 22px;font-weight: 600;">
                  搭建沟通桥梁 </p>
                <p
                  style="width: 364px; position: absolute;top: 120px;left: 30px;color:rgb(44, 62, 80);font-size: 17px;">
                  实时发布产业端-融资端需求，降低信息不对称，推动产融结合落地，提高产融对接效率。
                </p>
              </li>
              <li style="position: relative;">
                <img src="../assets/image (8).svg" alt="">
                <p style="position: absolute;top: 80px;left: 70px; color:black; font-size: 22px;font-weight: 600;">
                  创新合作模式 </p>
                <p
                  style="width: 367px;  position: absolute;top: 120px;left: 30px;color:rgb(44, 62, 80);font-size: 17px;">
                  探索符合军工产业的金融产品，解决军工企业资金周转问题，保障原材料采购，提升装备水平。
                </p>
              </li>
            </ul>
          </li>
          <li class="info2_li4">
            <div
              style="width: 83%;height: 50px;background-color: rgb(234, 218, 193);color: black;line-height: 50px;border-radius: 8px;opacity: 0.8;">
              <h2>推动军民融合</h2>
            </div>
            <ul>
              <li style="position: relative;left: -54px;">
                <img style="display: block;width: 437px;" src="../assets/image (9).svg" alt="">
                <p style="position: absolute;top: 45px;left: 183px; color:#c49958; font-size: 22px;font-weight: 600;">
                  促进技术转化 </p>
                <p
                  style="width: 222px; position: absolute;top: 95px;left: 139px;text-align: left; color:rgb(44, 62, 80);font-size: 17px;">
                  建立技术成果转化平台，促进军民技术交流与合作，加速技术双向转化，实现双赢。
                </p>
              </li>
              <li style="position: relative;left: -112px;">
                <img style="display: block;width: 437px;" src="../assets/image (9).svg" alt="">
                <p style="position: absolute;top: 45px;left: 182px;color:#c49958; font-size: 22px;font-weight: 600;">
                  提升经济发展
                </p>
                <p
                  style="width: 222px; position: absolute;top: 95px;left: 138px;text-align: left; color:rgb(44, 62, 80);font-size: 17px;">
                  支持军民融合产业园区建设和企业发展，培育社会经济增长点，促进国防建设与经济社会良性互动，推动行业健康有序发展。

                </p>
              </li>
            </ul>
          </li>
          </ul>

        </div>
      </div>
      <div class="aboutus_info1" v-else-if="activeTab == 5">
        <div style="margin-left: 20px; margin-top: 0px;">
          <h2>常见问题</h2>
          <ul>
            <!-- v-for="(item, index) in datalistwt" :key="index" -->
            <li v-for="(item, index) in arrays" :key="index">
              <p>{{ item.title }}</p>

              <span>{{ item.content }}
              </span>
              <img v-if="item.index != 0" :src="item.imges" alt="">
            </li>


          </ul>
          <div class="block" style="margin-top: 50px;position: fixed;top: 88%;left: 48%;">
            <el-pagination @current-change="handleCurrentChange1" :current-page="currentPage4"
              :page-sizes="[10, 20, 30, 40]" :page-size="pagesize1" layout="total, prev, pager, next, jumper"
              :total="total1">
            </el-pagination>
          </div>


        </div>
      </div>
      <div class="aboutus_info6" v-else-if="activeTab == 4">
        <div style="margin-left: 20px; margin-top: 10px;position: relative;">
          <el-amap vid="amapContainer" :center="center" :zoom="zoom" :events="events" class="amapClass">
            <el-amap-marker :position="center" :icon="icon" :label="label">
            </el-amap-marker>
          </el-amap>
          <div
            style="width: 240px; height: 230px;background-color: white;position: absolute;top: 300px;left: 98.5%;text-align: center;">
            <h2>联系我们</h2>
            <li style="text-align: center;width: 80%;margin: 0 auto;">
              <img src="../assets/phone.png" alt="">
              <p>电话：010-62960259</p>
            </li>
            <li style="text-align: center;margin-top: 15px;width: 100%;margin: 15px auto;">
              <img src="../assets/email.png" alt="">
              <p style="display: flex; width: 240px; flex-wrap: wrap; ">邮箱:ccgyljr@ccjr.freeqiye.com</p>
            </li>
          </div>
        </div>
      </div>
      <div class="aboutus_info" v-else>
        <h2 style="margin-top: 10px;color: #ccc;margin: 300px auto;">此内容正在建设中.....</h2>
      </div>
    </div>
    <!-- <el-tabs :tab-position="tabPosition" style="width: 65%;margin: 2% auto;position: relative;">
              <el-tab-pane label="新闻公告">

                  <div style="margin-left: 50px;">

                      <h2>新闻公告</h2>
                      <ul>

                          <li v-for="item in datalist" @click="handleClick()"
                              style="height: 100px; border-bottom:1px solid #ccc;line-height: 30px;display: flex;cursor: pointer;">
                              <div
                                  style="width: 59px;height: 63px;border-radius: 5px;background: linear-gradient(119deg, #EEC484 0%, #C49958 100%);margin-top: 20px;color: white;">
                                  <p>{{ item.datetimey }}</p>

                                  <p style="font-size: 19px;font-weight: 600;">{{ item.datetimer }}</p>

                              </div>
                                  <b
                                      style="display: block;color:#2c3e50; line-height: 100px;margin-left: 20px;font-family: Source Han Sans;">{{
          item.title }}</b>
                          </li>

                      </ul>
                  </div>
                  <div class="block" style="margin-top: 150px;">
                      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                          :current-page="currentPage4" :page-sizes="[100, 200, 300, 400]" :page-size="100"
                          layout="total, prev, pager, next, jumper" :total="400">
                      </el-pagination>
                  </div>
              </el-tab-pane>

              <el-tab-pane class="gsjj" label="公司简介">
                  <div>
                      <h2>平台简介</h2>
                      <img src="../assets/容器 65.png" style="margin-top: 20px;" alt="">
                      <p> 国科智造（北京）科技有限公司，是国防工业关键技术观察站的实体运营单位，是中国长城互联网信息中心与中国国防工业企业协会、北京北信源软件股份有限公司等单位，联合打造的国防工业智能制造和供应链服务实体机构。主要任务是在国家国防科技工业局和军委装备发展部等主管机关指导下，基于长城网信息安全底座，面向军工制造业企业开发一站式数字化服务平台，推动国防军工制造业数字化转型和供应链安全发展。
                      </p>
                      <p>

                          平台现已聚合军工领域2100多名首席科学家和自主可控发展领域专业组专家，构建了覆盖军用基础领域和应用领域的军事观察员队伍，拥有一批军工市场经验丰富的技术经理人，面向全国范围开展国防工业自主可控关键技术产品的需求发布、信息采集、研用对接、认证评估、技术指导和产业规划等工作，为企业开拓军工市场提供一站式服务，目标是成为推动国防军工产业自主可控高质量发展的重要支撑力量。
                      </p>
                      <p>

                          “国科智造APP”是国科智造（北京）科技有限公司联合北京北信源软件股份有限公司共同开发的高安全的国防工业大型产业链线上对接平台。拥有四大核心功能：信息实时发布、专家权威评估、线上加密通信、全方位配套服务。国科智造APP突破了“民参军”机制壁垒和障碍，构建了先进技术产品军事应用的绿色通道。
                      </p>
                      <p>
                          服务用户：国防军工管理机构、军工企事业单位、广大民参军企业、各领域专家工程师设计师、推动科技成果转化的技术经理人团队、以及提供指导与服务的应用验证与认证评估机构、行业协会联盟、产业园区、投融资机构和供应链金融机构等。
                      </p>
                  </div>
              </el-tab-pane>
              <el-tab-pane label="联系我们">
                  <h2>此内容正在建设中.....</h2>
              </el-tab-pane>
              <el-tab-pane label="常见问题">
                  <h2>此内容正在建设中.....</h2>
              </el-tab-pane>
          </el-tabs> -->
  </div>

  </div>
</template>
<script>
import { noticelist } from "@/request/api"
import { lazyAMapApiLoaderInstance } from "vue-amap";
import router from '@/router';
export default {
  name: "About",
  data() {
    return {
      map: null, // 地图实例存储变量
      zoom: 15, // 地图缩放比例。zoom值越小，越宏观、越大，越微观。大家可以更改zoom值看看效果
      events: {}, // 地图事件
      // 下方为上海虹桥火车站的经纬度坐标，我从网上搜索，大家可以更改这个坐标看看效果
      x: 116.258696,
      y: 39.975070,
      center: [116.258696, 39.975070],
      icon: 'https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png',
      // 文字标签
      label: {
        content: '地址: 北京市海淀区闵庄路3号玉泉慧谷5号楼',
        offset: [20, 20], // 文字偏移量

      },
      tabPosition: 'left',
      datalist: [
        // {
        //   createTimes: "111",
        //   datetimer: "111",
        //   noticeTitle: "啊啊啊啊啊啊",
        // },
        // {
        //   createTimes: "111",
        //   datetimer: "111",
        //   noticeTitle: "啊啊啊啊啊啊",
        // },
        // {
        //   createTimes: "111",
        //   datetimer: "111",
        //   noticeTitle: "啊啊啊啊啊啊",
        // },
        // {
        //   createTimes: "111",
        //   datetimer: "111",
        //   noticeTitle: "啊啊啊啊啊啊",
        // },
        // {
        //   createTimes: "111",
        //   datetimer: "111",
        //   noticeTitle: "啊啊啊啊啊啊",
        // },
        // {
        //   createTimes: "111",
        //   datetimer: "111",
        //   noticeTitle: "啊啊啊啊啊啊",
        // },
       
      ],
      datalistwt: [
        {
          title: '如何注册成为平台用户？',
          content: '在平台首页点击 “注册” 按钮，根据提示填写相关信息，包括企业名称、统一社会信用代码、联系人姓名、联系方式等，提交后等待平台审核，审核通过即可成为平台用户。',
          imges: require('../assets/xian.svg')
        },
        {
          title: '如何创建企业账号？',
          content: '通过企业管理员账号可以添加维护企业经办人账号及企业审核人账号。',
          imges: require('../assets/xian.svg')
        },
        {
          title: '如何在平台上发布融资需求？',
          content: '注册登录平台后，进入融资需求发布页面，填写详细的融资需求信息，确认无误后点击发布即可。',
          imges: require('../assets/xian.svg')
        },
        {
          title: '如何在平台上发布产业端需求？',
          content: '注册登录平台后，进入产业端需求发布页面，填写详细的产业端需求信息，确认无误后点击发布即可。',
          imges: require('../assets/xian.svg')
        },
        {
          title: '如果注册时提示 “企业信息已存在”，该如何处理？',
          content: '若出现此提示，可能您的企业已完成注册。请点击登录页面 “忘记密码”，通过预留手机重置密码；若无法找回，可拨打客服电话 [010-62960259]，提供企业营业执照等证明材料申请协助处理。',
          imges: require('../assets/xian.svg')
        },
        {
          title: '融资申请需要提供哪些材料？',
          content: '包括企业基础资料及真实贸易交易材料等，具体可联系专属金融业务经理，金融业务经理会根据不同金融产品需要发送客户对应的资料清单。',
          imges: require('../assets/xian.svg'),
          index: 0
        },
      ],
      datalistwt1: [
        {
          title: '如何在平台上筛选适合的金融产品？',
          content: '登录平台后，进入 “企业融资-融资申请”，可筛选“融资产品”，并有专属金融业务经理给出产品匹配建议。',
          imges: require('../assets/xian.svg')
        },
        {
          title: '提交融资需求后，多久能获得反馈？',
          content: '平台收到融资需求后，将在 1 - 5 个工作日内完成初步审核，并通过消息、短信或电话方式告知审核结果；若审核通过，平台将协助对接金融机构，后续沟通进度可在用户系统首页 “当前业务” 中实时查看。',
          imges: require('../assets/xian.svg')
        },
        {
          title: '需要抵押或担保吗？',
          content: '平台产品均以 “纯信用融资” 为主，无需固定资产抵押。但部分产品涉及订单/合同等质押。',
          imges: require('../assets/xian.svg')
        },
        {
          title: '平台如何保障用户信息安全？',
          content: '平台构建全流程安全防护体系,,数据传输环节采用端到端加密技术，通过行业标准加密协议构建安全通道，确保用户信息在终端设备与服务器之间的传输全程以密文形式交互，有效抵御数据窃听、篡改等安全风险；网络安全层面部署防火墙系统与入侵检测防御系统（IDS/IPS），实时监控过滤异常流量，构建边界安全屏障与动态防御体系；数据机房配备多重物理访问控制，并采用自动化加密备份与异地存储机制，保障数据可快速恢复；同时严格遵循《网络安全法》《数据安全法》《个人信息保护法》等法规,未经授权绝不向第三方披露用户信息。',
          imges: require('../assets/xian.svg')
        },
        {
          title: '申请过程中遇到审核退回问题，平台是否提供协助？',
          content: '是的。平台会持续跟进每笔贷款申请的进度，如遇资料退回、信息修改等问题，平台将第一时间通知用户配合处理。',
          imges: require('../assets/xian.svg')
        },
        {
          title: '如何与平台进行合作？',
          content: '如果您希望与平台进行合作，可以通过平台首页的 “联系我们” 与我平台联系，共同探讨合作事宜。',
          imges: require('../assets/xian.svg'),
          index: 0
        },

      ],
      datalistwt2: [
        {
          title: '如果遇到问题，如何联系平台客服？',
          content: '您可以通过以下方式联系平台客服：拨打客服电话 [010-62960259]，客服人员将在工作时间为您提供服务；或者发送邮件至 [ccgyljr@ccjr.freeqiye.com]，我们会在收到邮件后尽快回复您。',
          imges: require('../assets/xian.svg'),
          index: 0
        },

      ],
      pagesize: 6,
     
      currentPage4: 1,
      flag: false,    //是否显示
      flaghome: true,
      activeTab: 1,
      pagesize1: 6,
      pagenum1: 1,
      total1: 13,
      childActive: "1-1",
      tabList: [
        {
          title: "平台介绍",
          list: [
            {
              title: "平台简介",
              id: "1-1"
            },
            // {
            //   title: "公司介绍",
            //   id: "1-2"
            // }
          ],
          id: 1
        },
        {
          title: "平台使命",
          id: 2
        },
        {
          title: "新闻公告",
          id: 3
        },
        {
          title: "联系我们",
          id: 4
        },
        {
          title: "常见问题",
          id: 5
        },
        // {
        //   title: "下载app",
        //   id: 6
        // },

      ],
      total: 0,
      loading: false,
      paddingclass: 30,
      pagenum: 1,
      arrays: []

    }
  },
  mounted() {
    this.arrays = this.datalistwt;



  },
  methods: {

    datalists() {
      this.loading = true;
      let param = {
        pageSize: this.pagesize,
        pageNum: this.pagenum,
      };

      noticelist(param).then(res => {
        if (res.code == 200) {

          res.rows.forEach((item, index) => {


            var dateTimeObj = new Date(item.createTime);
            item.datetimer = dateTimeObj.getDate();
            item.createTimes = item.createTime.substring(5, 7);
          })
          this.datalist = res.rows;
          this.total = res.total;
        
         
          this.loading = false;
        }
      }).catch(err => { })
    },
    handleClick(item) {
      window.open('http://www.cgwcrpt.com/#/aboutdetails?item=' + item.noticeId)
      // window.open('http://192.168.1.18:17000/#/aboutdetails?item=' + item.noticeId)
      // var objJson =  encodeURIComponent(JSON.stringify(item));


      // window.open('http://localhost:8082/#/aboutdetails?item='+ item.noticeId)




    },

    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pagesize = val;
      this.datalists();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pagenum = val;
      this.datalists();
    },
    handleCurrentChange1(val) {
      console.log(`当前页: ${val}`);
      this.pagenum1 = val;

      if (val == 2) {
        this.arrays = this.datalistwt1;
      }
      if (val == 1) {
        this.arrays = this.datalistwt;
      }
      if (val == 3) {
        this.arrays = this.datalistwt2;
      }

    },
    handleToggleTab(index) {
      console.log(index, 235)
      this.activeTab = this.tabList[index].id;
      console.log(this.activeTab, 248);

      if (this.activeTab == 3) {
        this.datalists();
      }
      if (this.tabList[index].list) {
        this.childActive = this.tabList[index].list[0].id;
      } else {
        this.childActive = "";
      }
    },
    handleToggleChildTab(index, currentIndex) {
      console.log(index, currentIndex, 241)
      this.childActive = this.tabList[index].list[currentIndex].id;
    }
  }
}
</script>
<style scoped lang="scss">
body {
  background-image: url('../assets/c_bei.png');
}

.backimg {
  display: block;
  // position: absolute;
  // top: 0;
  // width: 100%;
}

::v-deep .el-tabs__nav-wrap::after {
  display: none;
}


::v-deep .el-tabs__active-bar {
  background-color: none;
  display: none;
}

::v-deep .el-tabs__item:hover {
  color: #C49958 !important;
}

::v-deep .el-tabs__item.is-active {
  color: #C49958 !important;
  border-bottom: 1px solid #ccc !important;
}

::v-deep .el-pager li.active {
  color: #EEC484 !important;
}

::v-deep .el-pager li:hover {
  color: #EEC484 !important;
}


.gsjj {
  div {
    p {
      text-align: left;
      text-indent: 2em;
      margin-top: 30px;
      font-size: 18px;
    }
  }
}

::v-deep .el-tabs__item {
  border-bottom: 1px solid #ccc;
}

::v-deep .el-tabs__item.is-left {
  position: relative;
  border-bottom: 1px solid #ccc;

  &::before {
    content: '';
    display: inline-block;
    width: 6px;
    height: 21px;
    background: #C49958;
    position: absolute;
    top: 50%;
    margin-top: -10.5px;
    left: 10px;
  }
}

// aboutus
.aboutus_container {
  width: 100%;
  // height: calc(100vh - 90px);
  height: calc(100vh - 120px);
  display: flex;
  justify-content: center;
  background-image: url("../assets/c_bei.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.aboutus_wrapper {
  width: 70%;
  display: flex;

  .aboutus_menu {
    width: 176px;
    height: 640px;
    background: #FFFFFF;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.15);
    box-sizing: border-box;
    padding: 13px 0 0 19px;

    .menu_title {
      display: flex;
      height: 25px;
      align-items: flex-end;
      margin-bottom: 21px;

      .title {
        font-size: 20px;
        font-weight: bold;
        letter-spacing: 0em;
        color: rgba(61, 61, 61, 0.5);
      }

      .border {
        width: 1px;
        height: 20px;
        background-image: linear-gradient(to bottom,
            rgba(216, 216, 216, 1) 10%,
            rgba(216, 216, 216, 1) 50%,
            transparent 50%);
        background-size: 2px 2px;
        background-repeat: repeat-y;
        margin: 0 9px;
      }

      .name {
        /* About us */
        height: 20px;
        opacity: 1;
        font-size: 14px;
        font-weight: bold;
        letter-spacing: 0em;
        color: rgba(61, 61, 61, 0.5);
        display: flex;
        align-items: flex-end;
        margin-bottom: 2px;
      }
    }
  }

  .aboutus_info {
    flex: 1;
    margin-left: 50px;

    p {
      text-align: left;
      line-height: 40px;
    }

  }

  .aboutus_info6 {
    flex: 1;
    margin-left: 50px;

    // p {
    //   text-align: left;
    //   line-height: 40px;
    // }

  }

  .aboutus_info1 {
    flex: 1;
    margin-left: 150px;

    p {
      text-align: left;
      line-height: 30px;
    }

    h2 {
      margin-right: 123px;
    }

    div {
      overflow: scroll;
      height: calc(90vh - 90px);
      margin-top: 0px;

      ul {
        li {
          width: 90%;
          text-align: left;
          margin-top: 10px;

          p {
            color: #C49958;
            font-size: 19px;
          }

          span {
            font-size: 18px;
            text-align: left;
            display: block;
            width: 109%;
          }

          img {
            margin-top: -5px;
            width: 110%;
            height: 4px;
          }
        }
      }

    }
  }

  .aboutus_info2 {
    flex: 1;
    margin-left: 50px;
    width: 80%;

    // p {
    //   text-align: left;
    //   line-height: 40px;
    // }
    .info2_ul {
      overflow-y: scroll;
      overflow-x: visible;
      width: 130%;
      height: calc(90vh - 90px);

      .info2_li {


        // position: relative;
        div {
          // text-align: left;
          // display: flex;

          // img {
          //   width: 40px;
          //   height: 40px;
          // }

          // h2 {
          //   margin-left: 15px;
          // }
        }

        // ul {
        //   display: flex;

        //   li {
        //     text-align: left;
        //     margin-top: 30px;
        //     font-size: 18px;
        //     width: 200px;
        //     margin-left: 100px;

        //     p {
        //       color: #C49958;
        //       font-size: 19px;
        //       font-weight: 500;
        //       text-align: center;
        //     }

        //     span {
        //       display: block;
        //       margin-top: 25px;
        //       font-size: 18px;

        //     }

        //     img {
        //       width: 300px;
        //       height: 300px;
        //       margin-top: -50px;
        //     }
        //   }
        // }
      }

      .info2_li1 {
        margin-top: -20px;
        margin-left: 50px;

        div {
          text-align: left;
          display: flex;

          img {
            width: 40px;
            height: 40px;
          }

          h2 {
            margin-left: 15px;
          }
        }

        ul {
          display: flex;

          li {
            text-align: left;
            margin-top: 30px;
            font-size: 18px;
            width: 200px;
            margin-left: 100px;

            p {
              color: #C49958;
              font-size: 19px;
              font-weight: 500;
              text-align: center;
            }

            span {
              display: block;
              margin-top: 25px;
              font-size: 18px;

            }

            img {
              width: 400px;
            }
          }
        }
      }

      .info2_li2 {
        margin-left: 50px;

        div {
          text-align: left;
          display: flex;
          margin-top: 25px;

          img {
            width: 40px;
            height: 40px;
          }

          h2 {
            margin-left: 15px;
          }
        }

        ul {
          display: flex;

          li {
            text-align: left;
            margin-top: 30px;
            font-size: 18px;
            width: 400px;
            margin-left: 100px;


            p {
              color: #C49958;
              font-size: 19px;
              font-weight: 500;

              width: 100%;
            }

            span {
              display: block;
              margin-top: 25px;
              font-size: 18px;

            }

            img {
              width: 400px;
              height: 4px;
            }
          }
        }
      }

      .info2_li3 {
        margin-left: 50px;

        div {
          text-align: left;
          display: flex;
          margin-top: 59px;

          img {
            width: 40px;
            height: 40px;
          }

          h2 {
            margin-left: 15px;
          }
        }

        ul {
          display: flex;

          li {
            text-align: left;
            margin-top: -20px;
            font-size: 18px;
            width: 400px;
            margin-left: 100px;


            p {
              color: #C49958;
              font-size: 19px;
              font-weight: 500;

              width: 70%;
            }

            span {
              display: block;
              margin-top: 25px;
              font-size: 18px;

            }

            img {
              width: 430px;
              height: 264px;
            }
          }
        }
      }

      .info2_li3 {

        div {
          text-align: left;
          display: flex;
          margin-top: 59px;

          img {
            width: 40px;
            height: 40px;
          }

          h2 {
            margin-left: 15px;
          }
        }

        ul {
          display: flex;

          li {
            text-align: left;
            margin-top: -20px;
            font-size: 18px;
            width: 400px;
            margin-left: 100px;


            p {
              color: #C49958;
              font-size: 19px;
              font-weight: 500;

              width: 70%;
            }

            span {
              display: block;
              margin-top: 25px;
              font-size: 18px;

            }

            img {
              width: 430px;
              height: 264px;
            }
          }
        }
      }

      .info2_li4 {
        margin-left: 50px;

        div {
          text-align: left;
          display: flex;
          margin-top: 19px;

          img {
            width: 40px;
            height: 40px;
          }

          h2 {
            margin-left: 15px;
          }
        }

        ul {
          display: flex;

          li {
            text-align: left;
            margin-top: 20px;
            font-size: 18px;
            // width: 400px;
            margin-left: 100px;


            p {
              color: #C49958;
              font-size: 19px;
              font-weight: 500;

              width: 90%;
            }

            span {
              display: block;
              margin-top: 25px;
              font-size: 18px;

            }

            img {
              width: 430px;
              // height: 264px;
            }
          }
        }
      }
    }

  }

  .menu_list {
    box-sizing: border-box;
    padding-left: 20px;

    li {
      cursor: pointer;

      .menu_item_title {
        box-sizing: border-box;
        padding-left: 5px;
        text-align: left;
        line-height: 42px;
        height: 42px;
        font-size: 18px;
        letter-spacing: 0em;
        color: #3D3D3D;
        border-bottom: 1px solid rgba(216, 216, 216, 0.5);
        // background: rgba(216, 216, 216, 0.5);
        position: relative;
        // font-weight: 600;
        font-size: 18px;

        i {
          margin-left: 15px;
        }

        .menu_bg {
          position: absolute;
          left: -25px;
          top: 0;

          img {
            width: auto;
            height: 100%;
            display: block;

          }

          .menu_bg_info {
            position: absolute;
            left: 30px;
            top: 0;
            color: #fff;

            i {
              margin-left: 30px;
            }
          }
        }

        &.active {
          color: #fff;
        }

      }

      .menu_drow {
        li {
          text-align: left;
          height: 34px;
          background: #F3F3F3;
          line-height: 34px;
          font-size: 14px;
          color: #3D3D3D;
          box-sizing: border-box;
          padding-left: 20px;
          border-bottom: 1px solid rgba(216, 216, 216, 0.5);
          cursor: pointer;

          &.active {
            color: #C49958;
          }
        }
      }
    }
  }
}

::v-deep .btn-prev {
  background: none !important;
}

::v-deep .number {
  background: none !important;
}

::v-deep .btn-next {
  background: none !important;
}

.box {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 60px;
  background-color: #ced;
}

/* 指定地图的宽高 */
.amapClass {
  width: 120%;
  height: 600px;
}
</style>